function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m0.43959 20.047c0-10.802 8.77-19.572 19.572-19.572 10.84 0 19.572 8.77 19.572 19.572 0 10.84-8.7323 19.572-19.572 19.572-10.802 0-19.572-8.7323-19.572-19.572z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m7.471 11.314h19.688l5.2354 5.4201v17.728l-0.73737 0.71515c-3.3182 2.7853-7.5212 4.4414-12.13 4.4414-3.945 0-7.6318-1.2045-10.655-3.3123l-1.401-1.0915z",
  fill: "#adb9ca"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m10.677 19.143c0-0.33875 0.26347-0.60223 0.60223-0.60223h18.707c0.33875 0 0.56459 0.26348 0.56459 0.60223v2.296c0 0.33875-0.22584 0.56459-0.56459 0.56459h-18.707c-0.33875 0-0.60223-0.22584-0.60223-0.56459z",
  fill: "#ecaec6"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m15.796 26.069c0-0.22584 0.22584-0.45167 0.45167-0.45167h13.889c0.22584 0 0.41403 0.22584 0.41403 0.45167v1.6938c0 0.22584-0.1882 0.41403-0.41403 0.41403h-13.889c-0.22584 0-0.45167-0.1882-0.45167-0.41403z"
}), React.createElement("path", {
  d: "m10.677 26.897c0-0.67751 0.60223-1.2797 1.2797-1.2797 0.71515 0 1.2797 0.60223 1.2797 1.2797 0 0.71515-0.56459 1.2797-1.2797 1.2797-0.67751 0-1.2797-0.56459-1.2797-1.2797z"
}), React.createElement("path", {
  d: "m15.796 32.392c0-0.22584 0.22584-0.45167 0.45167-0.45167h13.889c0.22584 0 0.41403 0.22584 0.41403 0.45167v1.6938c0 0.22584-0.1882 0.41403-0.41403 0.41403h-13.889c-0.22584 0-0.45167-0.1882-0.45167-0.41403z"
}), React.createElement("path", {
  d: "m10.677 33.22c0-0.67751 0.60223-1.2797 1.2797-1.2797 0.71515 0 1.2797 0.60223 1.2797 1.2797 0 0.71515-0.56459 1.2797-1.2797 1.2797-0.67751 0-1.2797-0.56459-1.2797-1.2797z"
}), React.createElement("path", {
  d: "m33.11 16.734h-5.2695v-5.4201z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m10.513 19.243c0-0.37725 0.26696-0.67067 0.61021-0.67067h18.955c0.34324 0 0.57207 0.29342 0.57207 0.67067v2.5569c0 0.37725-0.22883 0.62875-0.57207 0.62875h-18.955c-0.34324 0-0.61021-0.2515-0.61021-0.62875z",
  strokeWidth: 1.0623
}), React.createElement("path", {
  d: "m15.506 26.161c0-0.25414 0.22975-0.50827 0.4595-0.50827h14.13c0.22975 0 0.4212 0.25414 0.4212 0.50827v1.906c0 0.25414-0.19146 0.46592-0.4212 0.46592h-14.13c-0.22975 0-0.4595-0.21178-0.4595-0.46592z",
  strokeWidth: 1.07
}), React.createElement("path", {
  d: "m10.649 27.027c0-0.72708 0.6463-1.3734 1.3734-1.3734 0.76748 0 1.3734 0.6463 1.3734 1.3734 0 0.76748-0.6059 1.3734-1.3734 1.3734-0.72708 0-1.3734-0.6059-1.3734-1.3734",
  strokeWidth: 1.0732
}), React.createElement("path", {
  d: "m15.501 32.144c0-0.24927 0.2299-0.49854 0.4598-0.49854h14.139c0.2299 0 0.42148 0.24927 0.42148 0.49854v1.8695c0 0.24927-0.19158 0.45699-0.42148 0.45699h-14.139c-0.2299 0-0.4598-0.20772-0.4598-0.45699z",
  strokeWidth: 1.06
}), React.createElement("path", {
  d: "m10.658 33.058c0-0.73948 0.65731-1.3968 1.3968-1.3968 0.78056 0 1.3968 0.65731 1.3968 1.3968 0 0.78056-0.61623 1.3968-1.3968 1.3968-0.73948 0-1.3968-0.61623-1.3968-1.3968",
  strokeWidth: 1.0915
}), React.createElement("path", {
  d: "m32.49 16.57h-5.0058v-5.0261",
  strokeWidth: 0.93857
}), React.createElement("path", {
  d: "m7.5265 34.807v-23.372h19.806l5.2667 5.2917v17.996",
  strokeWidth: 0.98085
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.43959 20.047c0-10.802 8.77-19.572 19.572-19.572 10.84 0 19.572 8.77 19.572 19.572 0 10.84-8.7323 19.572-19.572 19.572-10.802 0-19.572-8.7323-19.572-19.572",
  fill: "none",
  strokeMiterlimit: 8
});

var SvgSurveyModelTabDiagnostic = function SvgSurveyModelTabDiagnostic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabDiagnostic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Diagnostic.d43a9953.svg";
export { ForwardRef as ReactComponent };